import { READ, FORM_UPDATE } from '../../../../store/type'
import { MAIN_ADDRESS } from "./type";
export const mutations = {
    [MAIN_ADDRESS + READ]: (state, { data, fieldInfoList }) => {
        state.data = data
        state.fieldInfoList = fieldInfoList
    }
};